'use client';

import { useState } from 'react';

import { EligibilityError, WetoStepChangeEvent } from '@app-types/eligibility';

import { ELIGIBILITY_STEP_NAME, ELIGIBILITY_STEP_STATUS } from '@constants/eligibility';

interface UseEligibilityStepsOptions {
    onReset?: () => void;
}

export function useEligibilitySteps({ onReset }: UseEligibilityStepsOptions = {}) {
    const [error, setError] = useState<EligibilityError>();
    const [currentStep, setCurrentStep] = useState<ELIGIBILITY_STEP_NAME>(ELIGIBILITY_STEP_NAME.SINGLE_SEARCH_ELIG);
    const [currentStepStatus, setCurrentStepStatus] = useState<ELIGIBILITY_STEP_STATUS>(ELIGIBILITY_STEP_STATUS.VALID);
    const [isFirstStep, setIsFirstStep] = useState<boolean>(true);

    const resetSteps = () => {
        setError(undefined);
        setCurrentStep(ELIGIBILITY_STEP_NAME.SINGLE_SEARCH_ELIG);
        setCurrentStepStatus(ELIGIBILITY_STEP_STATUS.VALID);
        setIsFirstStep(true);
    };

    const handleStepStatusChange = (status: ELIGIBILITY_STEP_STATUS) => {
        if (status === ELIGIBILITY_STEP_STATUS.RESET) {
            resetSteps();
            onReset?.();
        } else {
            setCurrentStepStatus(status);
        }
    };

    const handleStepChange = (event: WetoStepChangeEvent['event']) => {
        setCurrentStep(event.currentStep.name);
        setCurrentStepStatus(ELIGIBILITY_STEP_STATUS.INVALID);
        setIsFirstStep(event.history.length === 0);
    };

    const handleEligibilityChange = (step: ELIGIBILITY_STEP_NAME) => {
        setCurrentStep(step);
        setCurrentStepStatus(ELIGIBILITY_STEP_STATUS.INVALID);
    };

    return {
        error,
        setError,
        currentStep,
        setCurrentStep,
        currentStepStatus,
        setCurrentStepStatus,
        isFirstStep,
        setIsFirstStep,
        resetSteps,
        handleStepStatusChange,
        handleStepChange,
        handleEligibilityChange,
    };
}
